import React, { useState } from 'react';
import { Form, Input, Button, Card, Alert, Typography } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { loginUser } from "../api/user";
import LoginUserRequest from "../types/LoginUserRequest";
import { setToken } from "../data/storage";
import { useTexts } from "../hooks/useTexts";

const { Title, Text } = Typography;

export default function UserLogin(): JSX.Element {
    const { t } = useTexts();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const onFinish = async (values: any) => {
        setLoading(true);
        setError('');
        
        const request: LoginUserRequest = {
            username: values.username || '',
            password: values.password || ''
        };

        try {
            const resData = await loginUser(request);
            setToken("Bearer " + resData?.token);
            window.location.href = "/";
        } catch (err: any) {
            const errorMessage: string = err?.response?.data?.message
                || err?.message || t('common', 'error');
            setError(errorMessage);
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '100px' }}>
            <Card 
                style={{ 
                    width: 400, 
                    boxShadow: '0 8px 24px rgba(0,0,0,0.12)', 
                    borderRadius: '12px',
                    border: '1px solid #f0f0f0' 
                }}
                bordered={false}
            >
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <Title level={3} style={{ margin: 0, fontWeight: 600 }}>{t('auth', 'welcomeBack')}</Title>
                    <Text type="secondary">{t('auth', 'signInPrompt')}</Text>
                </div>

                {!!error && (
                    <Alert 
                        message={error} 
                        type="error" 
                        showIcon 
                        style={{ marginBottom: '24px' }} 
                    />
                )}

                <Form
                    name="login_form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    layout="vertical"
                    size="large"
                >
                    <Form.Item
                        name="username"
                        rules={[{ required: true, message: 'Please input your Username!' }]}
                    >
                        <Input 
                            prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.25)' }} />} 
                            placeholder={t('auth', 'username')} 
                            autoComplete="username"
                        />
                    </Form.Item>

                    <Form.Item
                        name="password"
                        rules={[{ required: true, message: 'Please input your Password!' }]}
                    >
                        <Input.Password
                            prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.25)' }} />}
                            placeholder={t('auth', 'password')}
                            autoComplete="current-password"
                        />
                    </Form.Item>

                    <Form.Item style={{ marginTop: '24px', marginBottom: 0 }}>
                        <Button 
                            type="primary" 
                            htmlType="submit" 
                            style={{ 
                                width: '100%', 
                                borderRadius: '8px', 
                                height: '48px',
                                fontSize: '16px',
                                fontWeight: 500 
                            }}
                            loading={loading}
                        >
                            {t('auth', 'login')}
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    );
}
